import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../shared';
import { ObservationDetailsComponent } from './observation-details.component';
import { RouterModule } from '@angular/router';
import { OBSERVATION_DETAILS_ROUTES } from './observation-details.route';
import { ObservationService } from './observation.service';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...OBSERVATION_DETAILS_ROUTES]),
    ],
    declarations: [
        ObservationDetailsComponent
    ],
    exports: [
        ObservationDetailsComponent
    ],
    providers: [
        ObservationService
    ]
})
export class ObservationDetailsModule {

}
